/**
 *
 * Asynchronously loads the AIInterviewersManagement component
 *
 */

import { Loader } from '@fountain/fountain-ui-components';

import loadable from 'utils/loadable';

export default loadable(() => import('./index.tsx'), {
  LoadingComponent: Loader,
});
